export default "__VITE_ASSET__Biz5JmDh__"